import React from 'react'
import PropTypes from 'prop-types'

import styles from 'containers/common/appFooter/AppFooter.module.scss'

export const AppFooter = ({ children }) => (
  <footer className={styles.footer}>
    <div className={styles.content}>{children}</div>
  </footer>
)

AppFooter.propTypes = {
  children: PropTypes.any,
}
